import {t} from '@lingui/macro'
import {toast} from 'react-hot-toast'

export const errorCurrentPositionToast = () =>
  toast.error(t`An error has occurred while determining your current position`)
